let config = null;          // {domain, token}
let products = [];          // normalized product list
let cart = [];              // {variantId, title, price, currency, image, qty, productType}
let activeFilter = 'all';

// ---------- persistence ----------
function loadConfig(){
  try{
    const raw = localStorage.getItem('shopify-config');
    if(raw){
      config = JSON.parse(raw);
      document.getElementById('inputDomain').value = config.domain || '';
      document.getElementById('inputToken').value = config.token || '';
      fetchProducts();
    }
  }catch(e){ /* no config saved yet */ }
}

function openSettings(){ document.getElementById('settingsOverlay').classList.add('open'); }
function closeSettings(){ document.getElementById('settingsOverlay').classList.remove('open'); }

async function saveSettings(){
  const domain = document.getElementById('inputDomain').value.trim().replace(/^https?:\/\//,'').replace(/\/$/,'');
  const token = document.getElementById('inputToken').value.trim();
  const statusEl = document.getElementById('settingsStatus');
  if(!domain || !token){
    statusEl.textContent = 'Please fill in both fields.';
    statusEl.className = 'modal-status err';
    return;
  }
  statusEl.textContent = 'Connecting...';
  statusEl.className = 'modal-status';
  config = { domain, token };
  const result = await fetchProducts();
  if(result.ok){
    try{ localStorage.setItem('shopify-config', JSON.stringify(config)); }catch(e){}
    statusEl.textContent = 'Connected.';
    statusEl.className = 'modal-status ok';
    setTimeout(closeSettings, 600);
  }else{
    statusEl.textContent = 'Could not connect: ' + result.error;
    statusEl.className = 'modal-status err';
  }
}

// ---------- Shopify Storefront API ----------
async function shopifyFetch(query, variables){
  let res;
  try{
    res = await fetch('https://' + config.domain + '/api/2026-07/graphql.json', {
      method:'POST',
      headers:{
        'Content-Type':'application/json',
        'X-Shopify-Storefront-Access-Token': config.token
      },
      body: JSON.stringify({ query: query, variables: variables })
    });
  }catch(networkErr){
    throw new Error('Network error: could not reach domain (' + networkErr.message + ')');
  }
  if(!res.ok){
    let bodyText = '';
    try{ bodyText = await res.text(); }catch(e){}
    throw new Error('HTTP ' + res.status + ' ' + res.statusText + ' - ' + bodyText.slice(0,200));
  }
  const json = await res.json();
  if(json.errors){
    throw new Error(json.errors.map(function(e){ return e.message; }).join('; '));
  }
  return json.data;
}

async function fetchProducts(){
  const catalogBody = document.getElementById('catalogBody');
  if(catalogBody){ catalogBody.innerHTML = '<div class="state-box"><h3>Loading</h3><p>Fetching products...</p></div>'; }
  const query = 'query Products { products(first: 100, sortKey: TITLE) { edges { node { id title productType featuredImage { url altText } variants(first: 1) { edges { node { id availableForSale price { amount currencyCode } } } } } } } }';
  try{
    const data = await shopifyFetch(query);
    products = data.products.edges.map(function(edge){
      const node = edge.node;
      const v = node.variants.edges[0] ? node.variants.edges[0].node : null;
      return {
        id: node.id,
        title: node.title,
        productType: (node.productType || '').toLowerCase(),
        image: node.featuredImage ? node.featuredImage.url : null,
        variantId: v ? v.id : null,
        available: v ? v.availableForSale : false,
        price: v ? v.price.amount : null,
        currency: v ? v.price.currencyCode : 'USD'
      };
    });
    renderCatalog();
    renderFeatured();
    return { ok: true };
  }catch(e){
    if(catalogBody){
      catalogBody.innerHTML = '<div class="state-box"><h3>Connect your store</h3><p>To show your products live here, enter your Shopify store address and Storefront API access token.</p><button onclick="openSettings()">Set up connection</button></div>';
    }
    return { ok: false, error: e.message };
  }
}

function classify(productType){
  const t = productType.toLowerCase();
  if(t.indexOf('watch') !== -1) return 'watch';
  if(t.indexOf('tshirt') !== -1 || t.indexOf('t-shirt') !== -1 || t.indexOf('shirt') !== -1) return 'shirt';
  return 'other';
}

function renderCatalog(){
  const catalogBody = document.getElementById('catalogBody');
  if(!catalogBody) return;
  const countEl = document.getElementById('catalogCount');
  const filtered = activeFilter === 'all' ? products : products.filter(function(p){ return classify(p.productType) === activeFilter; });

  if(products.length === 0){
    catalogBody.innerHTML = '<div class="state-box"><h3>Catalog is empty</h3><p>Connection is set up, but there are no products in your Shopify store yet. Add a product from your Shopify admin and it will appear here automatically.</p></div>';
    if(countEl) countEl.textContent = '';
    return;
  }
  if(filtered.length === 0){
    catalogBody.innerHTML = '<div class="state-box"><h3>No products in this category</h3><p>Choose a different category, or add a product of this type from your Shopify admin.</p></div>';
    if(countEl) countEl.textContent = '';
    return;
  }

  if(countEl) countEl.textContent = filtered.length + ' products';
  catalogBody.innerHTML = '<div class="grid">' + filtered.map(function(p, i){ return cardHtml(p, i); }).join('') + '</div>';
}

function shuffleArray(arr){
  const a = arr.slice();
  for(let i = a.length - 1; i > 0; i--){
    const j = Math.floor(Math.random() * (i + 1));
    const tmp = a[i]; a[i] = a[j]; a[j] = tmp;
  }
  return a;
}

function renderFeatured(){
  const el = document.getElementById('featuredBody');
  if(!el) return;
  const inStock = products.filter(function(p){ return p.available; });
  const pool = inStock.length ? inStock : products;
  if(pool.length === 0){ el.innerHTML = '<p style="color:var(--muted);font-size:14px;">No products yet.</p>'; return; }
  const picks = shuffleArray(pool).slice(0, Math.min(4, pool.length));
  el.innerHTML = '<div class="grid">' + picks.map(function(p, i){ return cardHtml(p, i); }).join('') + '</div>';
}

function cardHtml(p, i){
  const num = String(i+1).padStart(3,'0');
  const priceStr = p.price ? formatPrice(p.price, p.currency) : '-';
  const typeLabel = classify(p.productType) === 'watch' ? 'Watch' : classify(p.productType) === 'shirt' ? 'T-Shirt' : (p.productType || 'Product');
  const imgHtml = p.image ? '<img src="' + p.image + '" alt="' + escapeHtml(p.title) + '">' : '<span class="fallback">No image</span>';
  const oosBadge = !p.available ? '<span class="oos-badge">Sold out</span>' : '';
  const btnLabel = p.available ? 'Add to cart' : 'Sold out';
  const btnDisabled = !p.available ? 'disabled' : '';
  const productJson = JSON.stringify(p).replace(/'/g, "&apos;");
  return '<div class="card">' + oosBadge +
    '<span class="card-no">No. ' + num + '</span>' +
    '<div class="swatch">' + imgHtml + '</div>' +
    '<p class="card-type">' + typeLabel + '</p>' +
    '<h3 class="card-title">' + escapeHtml(p.title) + '</h3>' +
    '<div class="card-bottom">' +
    '<span class="price">' + priceStr + '</span>' +
    '<button class="add-btn" ' + btnDisabled + ' onclick=\'addToCart(' + productJson + ')\'>' + btnLabel + '</button>' +
    '</div></div>';
}

function formatPrice(amount, currency){
  const num = parseFloat(amount);
  const symbol = currency === 'USD' ? '$' : currency === 'EUR' ? 'EUR ' : currency === 'TRY' ? 'TL ' : currency + ' ';
  return symbol + num.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2});
}

function escapeHtml(str){
  const d = document.createElement('div');
  d.textContent = str;
  return d.innerHTML;
}

// ---------- filters ----------
document.querySelectorAll('.navlink').forEach(function(btn){
  btn.addEventListener('click', function(){
    if(btn.tagName === 'A') return; // real links navigate normally
    document.querySelectorAll('.navlink').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    activeFilter = btn.dataset.filter;
    const titleEl = document.getElementById('catalogTitle');
    if(titleEl){
      titleEl.textContent = activeFilter === 'watch' ? 'Watches' : activeFilter === 'shirt' ? 'T-Shirts' : 'Catalog';
    }
    renderCatalog();
  });
});

// ---------- cart ----------
function addToCart(p){
  const existing = cart.find(function(l){ return l.variantId === p.variantId; });
  if(existing){ existing.qty += 1; }
  else{
    cart.push({
      variantId: p.variantId, title: p.title, price: p.price,
      currency: p.currency, image: p.image, qty: 1
    });
  }
  renderCart();
  openCart();
}

function changeQty(variantId, delta){
  const line = cart.find(function(l){ return l.variantId === variantId; });
  if(!line) return;
  line.qty += delta;
  if(line.qty <= 0) cart = cart.filter(function(l){ return l.variantId !== variantId; });
  renderCart();
}

function removeLine(variantId){
  cart = cart.filter(function(l){ return l.variantId !== variantId; });
  renderCart();
}

function renderCart(){
  const linesEl = document.getElementById('drawerLines');
  const countEl = document.getElementById('cartCount');
  const subtotalEl = document.getElementById('subtotalVal');
  const checkoutBtn = document.getElementById('checkoutBtn');

  const totalQty = cart.reduce(function(s,l){ return s + l.qty; }, 0);
  countEl.style.display = totalQty > 0 ? 'flex' : 'none';
  countEl.textContent = totalQty;

  if(cart.length === 0){
    linesEl.innerHTML = '<div class="drawer-empty">Your cart is empty.</div>';
    subtotalEl.textContent = '-';
    checkoutBtn.disabled = true;
    return;
  }

  let subtotal = 0;
  let currency = cart[0].currency;
  linesEl.innerHTML = cart.map(function(l){
    subtotal += (parseFloat(l.price)||0) * l.qty;
    const imgHtml = l.image ? '<img src="' + l.image + '" alt="">' : '';
    return '<div class="drawer-line">' +
      '<div class="swatch">' + imgHtml + '</div>' +
      '<div class="line-info">' +
      '<span class="line-title">' + escapeHtml(l.title) + '</span>' +
      '<span>' + formatPrice(l.price, l.currency) + '</span>' +
      '<div class="line-qty">' +
      '<button class="qty-btn" onclick="changeQty(\'' + l.variantId + '\', -1)">-</button>' +
      '<span>' + l.qty + '</span>' +
      '<button class="qty-btn" onclick="changeQty(\'' + l.variantId + '\', 1)">+</button>' +
      '</div>' +
      '<button class="remove-line" onclick="removeLine(\'' + l.variantId + '\')">Remove</button>' +
      '</div></div>';
  }).join('');
  subtotalEl.textContent = formatPrice(subtotal, currency);
  checkoutBtn.disabled = false;
}

function openCart(){
  document.getElementById('cartDrawer').classList.add('open');
  document.getElementById('drawerOverlay').classList.add('open');
}
function closeCart(){
  document.getElementById('cartDrawer').classList.remove('open');
  document.getElementById('drawerOverlay').classList.remove('open');
}

async function goToCheckout(){
  const checkoutBtn = document.getElementById('checkoutBtn');
  checkoutBtn.disabled = true;
  checkoutBtn.textContent = 'Redirecting...';
  const mutation = 'mutation CartCreate($lines: [CartLineInput!]) { cartCreate(input: { lines: $lines }) { cart { checkoutUrl } userErrors { message } } }';
  const lines = cart.map(function(l){ return { merchandiseId: l.variantId, quantity: l.qty }; });
  try{
    const data = await shopifyFetch(mutation, { lines: lines });
    const url = data.cartCreate.cart ? data.cartCreate.cart.checkoutUrl : null;
    if(url){ window.open(url, '_blank'); }
    else{ throw new Error('no checkout url'); }
  }catch(e){
    alert('Could not redirect to checkout. Please check your connection settings.');
  }
  checkoutBtn.disabled = false;
  checkoutBtn.textContent = 'Checkout';
}

document.getElementById('settingsBtn').addEventListener('click', openSettings);
document.getElementById('cartBtn').addEventListener('click', openCart);

// pre-select category on dedicated category pages (e.g. /pages/watches)
(function(){
  const f = document.body.getAttribute('data-default-filter');
  if(f === 'watch' || f === 'shirt'){
    activeFilter = f;
    const btn = document.querySelector('.navlink[data-filter="' + f + '"]');
    if(btn){
      document.querySelectorAll('.navlink').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
    }
    const titleEl = document.getElementById('catalogTitle');
    if(titleEl){ titleEl.textContent = f === 'watch' ? 'Watches' : 'T-Shirts'; }
  }
})();

renderCart();
loadConfig();